const compare = (a: string = '', b: string = ''): number =>
  a.toLowerCase().localeCompare(b.toLowerCase())

export default compare
